import * as Sentry from '@sentry/browser';

const getSentryEnvironment = () => {
  switch (window.location.hostname) {
    case `${process.env.JA_PRODUCTION}`:
      return 'production';
    default:
      if ((window.location.hostname.includes('ddev.site') === true)) {
        return 'local';
      } else {
        return 'unknown-environment';
      }
  }
}

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    allowUrls: [`${process.env.JA_PRODUCTION}`],
    denyUrls: [
      // Ignore noisy browser extensions:
      /extensions\//i,
      // Chrome/Chromium specific
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // Safari specific
      /^safari-extension:\/\//i,
      // Firefox specific
      /^resource:\/\//i,
      'usercentrics.eu',
      'googletagmanager.com'
    ],
    dsn: `${process.env.SENTRY_BROWSER_PROJECT_DSN}`,
    environment: `${(getSentryEnvironment())}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Capture (valid) `console` events throughout the codebase /w sentry.
      // Limits messages to warnings, errors, debugs and traces, standard logs are NOT output for spamming reasons from other applications (browser apps, 3rd parties, ...)
      // Therefore: If we need to throw errors from JS do actually throw them (as you would in PHP), also console.log() -> console.error().
      // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/captureconsole/
      Sentry.captureConsoleIntegration({ levels: ['warn', 'error', 'debug', 'trace']}),
      // Capture erroneous calls to the Fetch and XHR APIs.
      // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/
      Sentry.httpClientIntegration(),
      // Since we've, on occasion, inlined JavaScript in template files, we'll also add the ContextLines integration to cover these. ;)
      // see: https://docs.sentry.io/platforms/javascript/configuration/integrations/contextlines/
      Sentry.contextLinesIntegration()
    ],
    // Just in case some env has set TYPO3 Context to Production, make sure browser tracing is only done in production.
    tracePropagationTargets: [`https://${process.env.JA_PRODUCTION}`],
    release: `${process.env.SENTRY_RELEASE}`,
    tracesSampleRate: 1.0,
  });
}
